module.exports = __webpack_public_path__ + "media/packs/images/details/conversations-0f9b39a7e3ba053cb9a3cc3d9338e443.svg";